import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-personalized-quote-footer',
  templateUrl: './personalized-quote-footer.component.html',
  styleUrls: ['./personalized-quote-footer.component.scss']
})
export class PersonalizedQuoteFooterComponent implements OnInit {
  @Input() isAdvanced = false;
  @Input() showPersonalizedQuote = false;
  @Input() buttonText = 'Email this scenario';
  @Input() icon = 'fa fa-paper-plane';
  @Input() refId = '';
  @Input() lpSupportEmail = '';

  @Output() onEmailScenarioOut = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onEmailScenario() {
    this.onEmailScenarioOut.emit();
  }

}
